const DrawerInitiator = {
  init({ button, drawer, content }) {
    this._button = button;
    this._drawer = drawer;
    this._content = content;
  },
};

export default DrawerInitiator;